import React from 'react'
import ReactDOM from 'react-dom/client'
import axios from 'axios'
import App from './App.js'
import './index.css'
// import App from './App';
import reportWebVitals from './reportWebVitals'
import {
	installAxiosRequestDeduper,
	installGlobalFetchRequestDeduper,
} from './utils/http/requestDeduper'

installGlobalFetchRequestDeduper()
installAxiosRequestDeduper(axios)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
